import React from "react";
import { useOutletContext } from "react-router";

import { ChicConainer } from "./styled/chicTheme";

import Banners from "./themes/chic/banners";
import CompanyInfo from "./themes/chic/companyInfo";
import Products from "./themes/chic/products";
import Portfolio from "./themes/chic/portfolio";
import Notice from "./themes/chic/notice";

const ChicTheme = ({ homepageInfo }) => {
  const { cmpnyNo, url } = useOutletContext();

  return (
    <ChicConainer>
      <Banners cmpnyNo={cmpnyNo} />
      <CompanyInfo url={url} homepageInfo={homepageInfo} />
      <Products homepageInfo={homepageInfo} cmpnyNo={cmpnyNo} url={url} />
      <Portfolio homepageInfo={homepageInfo} cmpnyNo={cmpnyNo} url={url} />
      <Notice homepageInfo={homepageInfo} cmpnyNo={cmpnyNo} url={url} />
    </ChicConainer>
  );
};

export default ChicTheme;
